export default {
  termsAndConditions: [],
};
